/**
 * Programs Archive — Filter, Search & Pagination
 */

import { initArchiveFilter } from './archive-filter.js';

document.addEventListener('DOMContentLoaded', () => {
	initArchiveFilter({
		archiveSelector: '.rmh-programs-archive',
		gridSelector: '[data-programs-grid]',
		countSelector: '[data-programs-count]',
		tabSelector: '.rmh-programs-tab',
		paginationButtonSelector: '.rmh-programs-page-btn',
		scrollTargetSelector: '.rmh-programs-tab',
		searchParam: 'program_search',
		errorContext: 'Programs filter error',
		gridWrapperClass: 'grid items-start grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 md:gap-y-[72px] lg:grid-cols-3',
		paginationContainerAttr: 'data-programs-pagination',
		defaultStrings: {
			noResults: 'No programs found.',
			error: 'Something went wrong. Please try again.',
		},
		stringsGlobal: 'rmhPrograms',
	});
});
